// This module manages the state of whether a session is being recorded
let isRecordingSession = false

// Returns whether the current session is being recorded
export function isSessionBeingRecorded(): boolean {
  return isRecordingSession
}

// Updates the recording state of the current session
export function setSessionRecordingState(recording: boolean): void {
  isRecordingSession = recording
}
